import PropTypes from 'prop-types';
import { Grid, IconButton, Typography } from '@mui/material';
import { useFieldArray, useFormState } from 'react-hook-form';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

import FormTextField from '../formTextField';
import FormAutocomplete from '../formAutocomplete';
import useStyles from './styles';
import dataLists from '../../../utils/dataLists';
import Button from '../../button';
import SubjectsField from '../formSubjectsField';

const {
  schoolOptions,
  subjectOptions,
  qualificationsOptions,
  examBoardOptions,
  academicYearOptions,
  academicValuesOptions,
  academicTypeOptions,
} = dataLists;

const FormLearnerInfoFields = ({
  control,
  getValues,
  watch,
  readOnly,
  setValue,
  trigger,
  type,
}) => {
  const { classes } = useStyles();
  const { errors } = useFormState({ control });
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'subjectList',
  });
  const watchSubjectList = watch('subjectList');
  const controlledSubjectFields = fields.map((field, index) => ({
    ...field,
    ...watchSubjectList[index],
  }));

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormAutocomplete
            name="currentSchool"
            control={control}
            options={schoolOptions}
            getOptionLabel={(option) => option}
            label="What school do they currently attend?"
            defaultValue={getValues('school.name')}
            inputProps={{
              label: 'Please Choose *',
              type: 'search',
            }}
            readOnly={readOnly}
            freeSolo
            handleHomeEndKeys
          />
        </Grid>
        <>
          <Grid item xs={12}>
            <Typography variant="body1" className={classes.label}>
              What Academic Year are they currently in?
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <FormAutocomplete
              name="academicType"
              control={control}
              options={academicTypeOptions}
              getOptionLabel={(option) => (option ? option.value : '')}
              defaultValue={getValues('academicType')}
              inputProps={{
                label: 'Please Choose *',
              }}
              readOnly={readOnly}
            />
          </Grid>
          <Grid item xs={6}>
            <FormAutocomplete
              name="academicValue"
              control={control}
              options={academicValuesOptions}
              getOptionLabel={(option) => (option ? option.value : '')}
              defaultValue={getValues('academicValue')}
              inputProps={{
                label: 'Please Choose *',
              }}
              readOnly={readOnly}
            />
          </Grid>
        </>
      </Grid>

      <Typography variant="body1" className={classes.label}>Which subjects do you require a tutor? </Typography>

      <SubjectsField
        control={control}
        getValues={getValues}
        setValue={setValue}
        trigger={trigger}
        errors={errors}
      />

      <Grid container columnSpacing={1}>
        <Grid item xs={12}>
          <FormTextField
            name="aboutYou"
            control={control}
            label="Any Additional information"
            inputProps={{
              multiline: true,
              rows: 7,
              margin: 'dense',
              placeholder: `Please tell us more about the learner...
              - Favourite subjects
              - Extra-curricular activities
              - Educational aspirations`,
            }}
            readOnly={readOnly}
          />
        </Grid>
      </Grid>
    </>
  );
};

FormLearnerInfoFields.defaultProps = {
  readOnly: false,
};

FormLearnerInfoFields.propTypes = {
  control: PropTypes.shape({}).isRequired,
  getValues: PropTypes.func.isRequired,
  trigger: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  type: PropTypes.oneOf(['parentLearnerCreate', 'parentLearnerEdit']).isRequired,
};

export default FormLearnerInfoFields;
